import { render, staticRenderFns } from "./StatWrapper.vue?vue&type=template&id=7b3406f8&scoped=true&"
import script from "./StatWrapper.vue?vue&type=script&lang=js&"
export * from "./StatWrapper.vue?vue&type=script&lang=js&"
import style0 from "./StatWrapper.vue?vue&type=style&index=0&id=7b3406f8&lang=scss&scoped=true&"
import style1 from "./StatWrapper.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b3406f8",
  null
  
)

export default component.exports